const videoBubble = document.getElementById('video-bubble');
if(videoBubble){
    const buublePlayer = document.getElementById('video-bubble-player');
    const buubleContainer = document.getElementById('video-bubble-container');
    const bubbleClose = document.getElementById('video-bubble-close');
    document.addEventListener('DOMContentLoaded', function(){

        

        if(!bubbleGetCookie()){
            setTimeout(() => {
                //console.log(buublePlayer.dataset.src);
                buublePlayer.src = buublePlayer.dataset.src
                videoBubble.classList.remove('closed');
                buublePlayer.muted = true;
                buublePlayer.play();
            }, 5000);
        }
    

        buubleContainer.addEventListener('click', function(e){
            if( !videoBubble.classList.contains('open') ){
                videoUp();
                e.stopPropagation();
            }
        });

        bubbleClose.addEventListener('click', function(){
            if( videoBubble.classList.contains('open') ){
                videoDown();
            }else{
                videoBubble.classList.add('closed');
                bubbleSetCookie();
            }
        });

        buublePlayer.addEventListener('click', function(e){
            if( !videoBubble.classList.contains('open') ){
                e.preventDefault();
            }
        });

        document.addEventListener('click', function (e) {
            if ( !videoBubble.contains(e.target) ) {
                videoDown();
            }
        });

    });

    function videoUp(){
        if(typeof hj == 'function'){
            hj('event', 'bubble_video_expanded');
        }
        buublePlayer.muted = false;
        buublePlayer.setAttribute("controls","controls");
        buublePlayer.play();
        videoBubble.classList.add('open');
    }
    function videoDown(){
        if(typeof hj == 'function'){
            hj('event', 'bubble_video_minimized');
        }
        buublePlayer.muted = true;
        buublePlayer.removeAttribute("controls");
        videoBubble.classList.remove('open');
    }
    function bubbleSetCookie() {
        if(typeof hj == 'function'){
            hj('event', 'bubble_closed');
        }
        const d = new Date();
        d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = 'bubble_closed' + "=" + 'true' + ";" + expires + ";path=/";
    }
    function bubbleGetCookie() {
        const name = 'bubble_closed';
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }
}